import React, { FC } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@mui/material';
import { get } from 'lodash';

const MUICheckboxField: FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let event = { target: { value: get(e, 'target.checked', false) } };
		updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
	};

	return (
		<>
			<FormControl error={error} {...restProps} sx={{ maxHeight: '98px', justifyContent: 'flex-end' }}>
				<FormGroup>
					<FormControlLabel
						disabled={isDisabled}
						label={label}
						checked={fieldValue}
						control={<Checkbox onChange={handleOnChange} />}
					/>
				</FormGroup>
			</FormControl>
			{error && <FormHelperText error>{errorMessage}</FormHelperText>}
		</>
	);
};
export default MUICheckboxField;
